import { render } from "./product-engraving.vue?vue&type=template&id=ae4bdfd6"
import script from "./product-engraving.vue?vue&type=script&lang=js"
export * from "./product-engraving.vue?vue&type=script&lang=js"

import "./product-engraving.vue?vue&type=style&index=0&id=ae4bdfd6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__